/**
 * ****************************************************************************
 * @description     :   Saga to call api to get data for page report
 * @created at      :   2020/07/18
 * @created by      :   QuanHVM
 * @package         :   report-daily-react
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { all, takeEvery, put, call, fork, takeLatest } from "redux-saga/effects";

/**
 * Import for redux
 */
import Types from "./action-types";
import Actions from "./actions";
import Factory from "./factory";

/**
 * Listenning action type FETCHING_REPORTS to get reports and change state of reports data
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/18 - create
 * @access : public
 */
export function* getReports() {
    yield takeEvery(Types.FETCHING_REPORTS, function* (data) {
        try {
            // call api
            const response = yield call(Factory.GetReports, data.condition);
            // call action update data when success
            yield put(Actions.GetReportsSuccess(response));
        } catch (error) {
            // call action reset data when failure
            yield put(Actions.GetReportsFailure(error));
        }
    });
}

/**
 * Listenning action type DESTROY_REPORTS to destroy report detail and change state of reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/25 - create
 * @access : public
 */
export function* destroyReports() {
    yield takeLatest(Types.DESTROY_REPORTS, function* (data) {
        try {
            // call api
            yield call(Factory.DestroyReports, data.listRemoves);
            // call action update data when success
            yield put(Actions.GetReports());
        } catch (error) {
            // call action reset data when failure
            yield put(Actions.GetReportsFailure(error));
        }
    });
}

/**
 * Listenning action type FETCHING_REPORT_DETAIL to get report detail and change state of report detail data
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/25 - create
 * @access : public
 */
export function* getReportDetail() {
    yield takeEvery(Types.SHOW_DATA_REPORT_INIT, function* (data) {
        try {
            // call api
            const response = yield call(Factory.GetReportDetail, data.id);
            // call action update data when success
            yield put(Actions.GetReportDetailSuccess(response));
        } catch (error) {
            // call action reset data when failure
            yield put(Actions.GetReportDetailFailure(error));
        }
    });
}

/**
 * Listenning action type ADD_REPORT to insert report detail and change state of reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/25 - create
 * @access : public
 */
export function* postReport() {
    yield takeLatest(Types.ADD_REPORT, function* (data) {
        try {
            // call api
            yield call(Factory.PostReport, data.report);
            // call action update data when success
            yield put(Actions.GetReports());
        } catch (error) {
            // call action reset data when failure
            yield put(Actions.GetReportsFailure(error));
        }
    });
}

/**
 * Listenning action type ADD_REPORT to insert report detail and change state of reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/27 - create
 * @access : public
 */
export function* isShowPopupReport() {
    yield takeLatest(Types.IS_SHOW_POPUP_REPORT_DETAIL, function* () {
        try {
            // call api
            yield call(Actions.IsShowPopupReport());
        } catch (error) {
            // console.log(`Saga isShowPopupReport:  ${error.message}`);
        }
    });
}

/**
 * Listenning action type CLEAR_STORAGE reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/27 - create
 * @access : public
 */
export function* clearStorage() {
    yield takeLatest(Types.CLEAR_STORAGE, function* () {
        try {
            // call api
            yield call(Factory.ClearStorage());
        } catch (error) {
            // console.log(`Saga isShowPopupReport:  ${error.message}`);
        }
    });
}

/**
 * Fork all function in saga midleware
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/19 - create
 * @access : public
 */
export default function* rootSaga() {
    yield all([
        fork(getReports),
        fork(destroyReports),
        fork(getReportDetail),
        fork(postReport),
        fork(isShowPopupReport),
        fork(clearStorage)
    ]);
}